import { createFileRoute } from '@tanstack/react-router'

import { HomeContentContainer } from '@/components'
import { RoleForm } from '@/components/pages/Admin/RoleManagement/Form/RoleForm'
import { useTranslations } from '@/hooks/useTranslations'

export const Route = createFileRoute('/(dashboard)/admin/role/create')({
  component: RoleCreatePage,
})

function RoleCreatePage() {
  const t = useTranslations('admin.role_management.create')

  return (
    <HomeContentContainer title={t('title')}>
      <RoleForm action="create" />
    </HomeContentContainer>
  )
}

